import Head404 from '@/components/atoms/head-404/head404';
import Layout from '@/components/organisms/layout/layout';
import SEO from '@/shared/seo';

interface GeneralPageTemplatePropsObject {
  metaTitulo: string;
  metaDescripcion: string;
  metaImagen: any;
  noIndex: boolean;
  urlCanonical: string;
  children: any;
  hasLoader: boolean;
  isPrivate: boolean;
}

interface GeneralPageTemplateProps {
  data: GeneralPageTemplatePropsObject;
  children: any;
  hasLoader?: boolean;
  isPrivate?: boolean;
  hideSide?: boolean;
  sideMenu?: any;
  isMain?: boolean;
  isActive?: boolean;
  serviceId?: string[];
}

const GeneralPageTemplate = ({
  data,
  children,
  hasLoader,
  isPrivate,
  hideSide,
  sideMenu,
  isMain,
  isActive,
  serviceId,
}: GeneralPageTemplateProps) => {
  const { metaTitulo, metaDescripcion, metaImagen, noIndex, urlCanonical } = data;

  return (
    <Layout
      hasLoader={hasLoader}
      isPrivate={isPrivate}
      hideSide={hideSide}
      sideMenu={sideMenu}
      isMain={isMain}
      serviceId={serviceId}
    >
      {isActive ? (
        <>
          <SEO
            title={metaTitulo}
            description={metaDescripcion}
            image={metaImagen?.file?.url}
            noIndex={noIndex}
            urlCanonical={urlCanonical}
            noCanonical={false}
            lang="es"
          />
          {children}
        </>
      ) : (
        <>
          <SEO title="Pagina no encontrada" noIndex />
          <Head404 />
        </>
      )}
    </Layout>
  );
};

export default GeneralPageTemplate;
